import "../assets/widgets-core.css";
import { inject as z } from "vue";
function s(i, t) {
  return t ? Object.keys(t).reduce(
    (e, a) => e.replace(`{${a}}`, t[a].toString()),
    i
  ) : i;
}
const J = Symbol("i18n");
var K = typeof global == "object" && global && global.Object === Object && global, Q = typeof self == "object" && self && self.Object === Object && self, Y = K || Q || Function("return this")(), r = Y.Symbol;
r && r.toStringTag;
r && r.toStringTag;
const ii = () => z(J, {
  t: (i, t) => s(i, t) || i,
  tc: (i, t, e) => s(i, e) || i
});
var c;
(function(i) {
  i.ApplyDiscount = "apply-discount", i.Dismiss = "dismiss", i.Engage = "engage", i.Hide = "hide", i.NoAction = "no-action", i.Fallback = "none", i.GenericLinkClick = "generic-link-click", i.LoadScript = "load-script", i.OpenBookingEngine = "open-be", i.OpenUri = "open-uri", i.PredictiveAudience = "predictive-audience", i.SendForm = "send-form", i.SendSaveSearch = "send-save-search", i.SendSiteContact = "send-site-contact", i.SendSubscribe = "send-subscribe", i.Show = "show", i.Login = "login", i.TranslateDocumentBody = "translate-document-body";
})(c || (c = {}));
var l;
(function(i) {
  i.Resend = "resend", i.Signup = "signup", i.Signin = "signin", i.Validation = "validation";
})(l || (l = {}));
var u;
(function(i) {
  i.Arabic = "ar", i.Basque = "eu", i.Bulgarian = "bg", i.Catalan = "ca", i.Chinese = "zh", i.ChineseTraditional = "zh-TW", i.Croatian = "hr", i.Czech = "cs", i.Danish = "da", i.Deutsch = "de", i.Dutch = "nl", i.English = "en", i.Estonian = "et", i.Finnish = "fi", i.French = "fr", i.Greek = "el", i.Hebrew = "he", i.Hungarian = "hu", i.Icelandic = "is", i.Indonesian = "id", i.Italian = "it", i.Japanese = "ja", i.Korean = "ko", i.Lithuanian = "lt", i.Norwegian = "no", i.Polish = "pl", i.Portuguese = "pt", i.Romanian = "ro", i.Russian = "ru", i.Slovenian = "sl", i.Spanish = "es", i.Swedish = "sv", i.Thai = "th", i.Turkish = "tr", i.Ukrainian = "uk", i.Vietnamese = "vi";
})(u || (u = {}));
var d;
(function(i) {
  i.Timing = "timing", i.Oraculo = "oraculo", i.VisitorProfile = "visitorProfile", i.VisitorBehaviour = "visitorBehaviour", i.Search = "search", i.TravelParty = "travelParty", i.DataVariables = "dataVariables", i.Demand = "demand", i.Integrations = "integrations";
})(d || (d = {}));
var g;
(function(i) {
  i.Exclude = "exclude", i.Include = "include";
})(g || (g = {}));
var f;
(function(i) {
  i.Any = "any", i.Is = "is", i.Are = "are", i.IsBetween = "isBetween", i.AreBetween = "areBetween", i.IsLower = "isLower", i.AreLower = "areLower", i.IsHigher = "isHigher", i.IsGreater = "isGreater", i.AreGreater = "areGreater", i.IsBefore = "isBefore", i.AreBefore = "areBefore", i.IsAfter = "isAfter", i.AreAfter = "areAfter", i.Contain = "contain";
})(f || (f = {}));
var p;
(function(i) {
  i.Is = "is", i.IsNot = "isNot", i.AnyValue = "anyValue", i.NotAnyValue = "notAnyValue", i.Lower = "lower", i.Greater = "greater", i.Contains = "contains", i.NotContains = "notContains";
})(p || (p = {}));
var v;
(function(i) {
  i.Registered = "registered", i.NonRegistered = "non_registered", i.RegisteredAndLogged = "registered", i.NotRegisteredAndNotLogged = "non_registered_nor_logged", i.RegisteredOrLogged = "registered_all", i.RegisteredAndNotLogged = "registered_non_logged", i.NotLogged = "non_registered";
})(v || (v = {}));
var m;
(function(i) {
  i.Logged = "logged", i.NonLogged = "nonLogged";
})(m || (m = {}));
var h;
(function(i) {
  i.Any = "any", i.First = "first", i.All = "all", i.Search = "search", i.Booked = "booked", i.Custom = "custom";
})(h || (h = {}));
var S;
(function(i) {
  i.Colors = "colors", i.Fonts = "fonts", i.Button = "button", i.Background = "background", i.Overlay = "overlay";
})(S || (S = {}));
var y;
(function(i) {
  i.None = "none", i.Uppercase = "uppercase", i.Lowercase = "lowercase", i.Titlecase = "titlecase";
})(y || (y = {}));
var b;
(function(i) {
  i.Google = "google", i.File = "file", i.Regular = "regular";
})(b || (b = {}));
var L;
(function(i) {
  i.Custom = "custom", i.Square = "square", i.Medium = "medium", i.Rounded = "rounded";
})(L || (L = {}));
var _;
(function(i) {
  i.Percentage = "%", i.Pixels = "px", i.Rem = "rem", i.Em = "em";
})(_ || (_ = {}));
var w;
(function(i) {
  i.Solid = "solid", i.Outline = "outline";
})(w || (w = {}));
var T;
(function(i) {
  i.Url = "url", i.DefaultText = "default_text", i.CustomText = "custom_text", i.NotLinked = "not_linked", i.CustomUrl = "custom_url";
})(T || (T = {}));
var n;
(function(i) {
  i.NowViewing = "nowViewing", i.TodayViewed = "todayViewed", i.BookedToday = "bookedToday", i.LastReservation = "lastReservation", i.DiscountToday = "discountToday", i.TodaySpecialOffer = "todaySpecialOffer";
})(n || (n = {}));
var R;
(function(i) {
  i.ApplyPromoCode = "apply_promo_code", i.OpenUrl = "open_url", i.OpenMailClient = "open_mail_client", i.CallPhoneNumber = "call_phone_number", i.CloseTool = "close_tool", i.EmailCapture = "email_capture", i.SavedSearch = "saved_search", i.GoMainStep = "go_main_step", i.SendForm = "form", i.OpenBookingEngine = "send_to_be", i.Submit = "submit", i.LastSearch = "send_to_last_search";
})(R || (R = {}));
var C;
(function(i) {
  i.Default = "default", i.Coupon = "coupon", i.Rate = "rate", i.Corporative = "corpo", i.Group = "group";
})(C || (C = {}));
var k;
(function(i) {
  i.Note = "note", i.Layer = "layer", i.Exit = "exit", i.Inliner = "inliner";
})(k || (k = {}));
var B;
(function(i) {
  i.Success = "success", i.Failure = "failure", i.Main = "main";
})(B || (B = {}));
var A;
(function(i) {
  i.LoginSignin = "login-signin", i.LoginRegister = "login-register", i.LoginSuccess = "login-success";
})(A || (A = {}));
var O;
(function(i) {
  i.Activity = "activity", i.Button = "button", i.Countdown = "countdown", i.EmailCapture = "emailCapture", i.Form = "form", i.Heading = "heading", i.ImageWithBehaviour = "imageWithBehaviour", i.Icon = "icon", i.Paragraph = "paragraph", i.Perks = "perks", i.SavedSearch = "savedSearch", i.Spacer = "spacer", i.Login = "login";
})(O || (O = {}));
var o;
(function(i) {
  i.None = "none", i.WebExclusive = "web_exclusive", i.SubjectToAvailibity = "subject_to_availability", i.OnlyForSpecificRates = "only_for_specific_rates", i.OnlyForRegisterdUsers = "only_for_registered_users";
})(o || (o = {}));
var N;
(function(i) {
  i.Bullets = "bullets", i.Highlights = "highlights";
})(N || (N = {}));
var I;
(function(i) {
  i.None = "none", i.Solid = "solid", i.Outline = "outline";
})(I || (I = {}));
var P;
(function(i) {
  i.Normal = "normal", i.Compact = "compact";
})(P || (P = {}));
var V;
(function(i) {
  i.Date = "date", i.Time = "time";
})(V || (V = {}));
var x;
(function(i) {
  i.Visitor = "visitor", i.Hotel = "hotel";
})(x || (x = {}));
var D;
(function(i) {
  i.Out = "out", i.Inside = "inside";
})(D || (D = {}));
var F;
(function(i) {
  i.Single = "single", i.Multiple = "multiple";
})(F || (F = {}));
var M;
(function(i) {
  i.ShortText = "shortText", i.Email = "email", i.Phone = "phone", i.Date = "date", i.LongText = "longText", i.DropDown = "dropdown", i.Selection = "selection";
})(M || (M = {}));
var U;
(function(i) {
  i.Top = "T", i.Bottom = "B", i.Left = "L", i.Right = "R", i.UpperLeft = "UL", i.UpperRight = "UR", i.UpperMidLeft = "UML", i.UpperMidRight = "UMR", i.LowerMidLeft = "LML", i.LowerMidRight = "LMR", i.LowerLeft = "LL", i.LowerRight = "LR";
})(U || (U = {}));
var E;
(function(i) {
  i.Mobile = "mobile", i.Desktop = "desktop";
})(E || (E = {}));
var j;
(function(i) {
  i.EveryPage = "on_every_page", i.OncePerVisit = "once_per_visit", i.OncePerVisitor = "once_per_visitor", i.OncePerProperty = "once_per_property", i.OncePerBrand = "once_per_brand";
})(j || (j = {}));
var G;
(function(i) {
  i.Load = "load", i.Scroll = "scroll", i.Idle = "idle";
})(G || (G = {}));
var H;
(function(i) {
  i.Regular = "regular", i.Compact = "compact";
})(H || (H = {}));
var q;
(function(i) {
  i.Single = "single", i.Multi = "multi";
})(q || (q = {}));
var W;
(function(i) {
  i.Bar = "bar", i.Circular = "circular", i.CustomImage = "custom-image", i.Fullscreen = "full-screen", i.FullscreenMini = "full-screen-mini", i.LowerNotification = "lower-notification", i.NotificationTab = "notification-tab", i.Sidebar = "sidebar", i.SideGradient = "side-gradient", i.SlideIn = "slide-in", i.Square = "square", i.SquareImage = "square-image", i.Sticky = "sticky", i.StickyImage = "sticky-image";
})(W || (W = {}));
var $;
(function(i) {
  i.Left = "left", i.Center = "center", i.Right = "right";
})($ || ($ = {}));
n.NowViewing + "", n.TodayViewed + "", n.BookedToday + "", n.LastReservation + "", n.DiscountToday + "", n.TodaySpecialOffer + "";
o.None + "", o.SubjectToAvailibity + "", o.WebExclusive + "", o.OnlyForRegisterdUsers + "", o.OnlyForSpecificRates + "";
export {
  ii as S
};
//# sourceMappingURL=widgets-core.es.Dphhb0qH.js.map
